module.exports = __webpack_public_path__ + "static/media/technology-real-time-icon.a40571a8.png";